import axios from "../../config/axiosConfig";
import { CREATE_HSNCODE, GET_HSNCODE, HSNCODE_REQUEST, DELETE_HSNCODE, UPDATE_HSNCODE, HSNCODE_REQUEST_FAILURE } from "../types";
import { addMasterInOption, getMasterOptions, updateMasterInOption } from "./master-options-actions";

export const getHsnCodes = () => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: HSNCODE_REQUEST });
      const { auth } = getState();
      let params = { customerId: auth?.user?.Customer_Id };
      if (!auth?.company?.Common_Master) {
        params = { ...params, companyId: auth.company?.id }
      }
      return axios.get("/hsn/getAll", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_HSNCODE, payload: response.data });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: HSNCODE_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: HSNCODE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const createHsnCode = (hsncode) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      dispatch({ type: HSNCODE_REQUEST });

      return axios.post("/hsn/add", hsncode,
        { params: { userId: auth.user?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id }}
      ).then((response) => {
        if (response.data) {
          dispatch({ type: CREATE_HSNCODE, payload: response.data });
          dispatch(addMasterInOption('hsnCodes', response.data));
        } else {
          dispatch({
            type: HSNCODE_REQUEST_FAILURE,
            error: "Hsn code create failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: HSNCODE_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: HSNCODE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const updateHsnCode = (id, data) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: HSNCODE_REQUEST });
      const { auth } = getState();
      return axios.put("/hsn/update", { id, data }, { params: { userId: auth.user?.id }}).then((response) => {
        if (response.data) {
          dispatch({
            type: UPDATE_HSNCODE,
            payload: { id, data: response.data },
          });
          dispatch(updateMasterInOption('hsnCodes', id, response.data));
          dispatch(getMasterOptions('item'));
        } else {
          dispatch({
            type: HSNCODE_REQUEST_FAILURE,
            error: "Hsn code update failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: HSNCODE_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: HSNCODE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const deleteHsnCode = (id) => {
  return async (dispatch) => {
    try {
      dispatch({ type: HSNCODE_REQUEST });
      return axios.delete(`/hsn/delete/${id}`).then((response) => {
        if (response.data) {
          dispatch({ type: DELETE_HSNCODE, id: id });
          dispatch(updateMasterInOption('hsnCodes', id));
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: HSNCODE_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: HSNCODE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};
